
// Diverse Buttons oder Seitenaufrufe in der Oberflaeche sollen Google Events Loggen.
$(function(){
    $(document).on('click', '.google_event_btn', function(){
        googleTrackEvent($(this).data('google_event_name'));
    });

    $(document).on('change', '.google_event_select', function(){
        googleTrackEvent($(this).data('google_event_name'));
    });
});

function googleTrackEvent(eventName,params = {}){
    if(!eventName) return;
    if(typeof ALLOW_GOOGLE_EVENTS == 'undefined' || !ALLOW_GOOGLE_EVENTS) return;

    if(typeof gtag === 'function'){
        gtag('event', eventName,params);
    }
}
